import React, { useState, useEffect, useRef, ReactNode } from 'react';
import styled from 'styled-components';

// import ClipboardIcon from '@material-ui/icons/Assignment';
// import { pages } from './svg';
// import ClipboardSuccessIcon from '@material-ui/icons/AssignmentTurnedIn';
import { copyTextToClipboard } from '#/lib/string';

import MaterialSymbol from './MaterialSymbol';

const MinimalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: copy;
  &:hover {
    color: var(--primary3);
  }
`;

const Wrapper = styled.div<{ $taller: boolean; $inline: boolean }>`
  min-height: ${({ $taller }) => ($taller ? 62 : 42)}px;
  width: ${({ $inline }) => ($inline ? 'initial' : '100%')};
  line-height: 1.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background: var(--mainDark);
  border: 1px solid transparent;
  padding: 0px 16px;
  cursor: copy;
  &:hover {
    color: var(--primary3);
  }
`;

const ChildrenWrapper = styled.div`
  overflow-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  user-select: all;
`;

const MaterialSymbolStyled = styled(MaterialSymbol)`
  /* position: relative; */
  cursor: copy;
  /* padding: 2px; */
  /* margin: -2px 0 -2px 4px; */
  margin-left: 4px;
`;

export const useCopyToClipboard = () => {
  const [recentlyCopied, setRecentlyCopied] = useState(false);

  // Reset success state after short delay
  const timeoutRef = useRef<number>();
  useEffect(() => {
    if (recentlyCopied === true) {
      timeoutRef.current = window.setTimeout(
        () => setRecentlyCopied(false),
        1800
      );
    }
  }, [recentlyCopied]);
  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  });

  return {
    onCopy: (copyText: string) => {
      copyTextToClipboard(copyText);
      setRecentlyCopied(true);
    },
    recentlyCopied,
  };
};

type Props = {
  copyText?: string;
  taller?: boolean;
  inline?: boolean;
  children?: ReactNode;
  layout?: 'minimal' | 'iconOnly';
};

const CopyToClipboard = ({
  copyText,
  taller,
  inline,
  layout,
  children,
}: Props) => {
  const { onCopy, recentlyCopied } = useCopyToClipboard();

  if (!copyText) {
    return null;
  }

  if (layout === 'iconOnly') {
    return (
      <div
        style={{ display: 'inline' }}
        onClick={() => {
          onCopy(copyText);
        }}
      >
        <MaterialSymbolStyled
          icon={recentlyCopied ? 'check' : 'content_copy'}
          fontSize="small"
        />
      </div>
    );
  }

  if (layout === 'minimal') {
    return (
      <MinimalWrapper
        title="Click to copy to clipboard"
        onClick={() => {
          onCopy(copyText);
        }}
      >
        {children ?? copyText}
        {recentlyCopied && (
          <MaterialSymbolStyled icon="check" fontSize="small" />
        )}
      </MinimalWrapper>
    );
  }

  return (
    <Wrapper
      $taller={!!taller}
      $inline={!!inline}
      title="Click to copy to clipboard"
      onClick={() => {
        onCopy(copyText);
      }}
    >
      <ChildrenWrapper>{children ?? copyText}</ChildrenWrapper>
      <MaterialSymbolStyled
        icon={recentlyCopied ? 'check' : 'content_copy'}
        fontSize="small"
      />
    </Wrapper>
  );
};

export default CopyToClipboard;
